import { useDispatch, useSelector } from 'react-redux';
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField';
import { updateDashboardLearningContinuum } from '../../../../../../store/actions/class-marking.actions';

const SelectLearningContinuumSimple = () => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const lcIds = useSelector((state) => state?.classMarking?.dashboard?.lcIds || []);
  const options = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  const dispatch = useDispatch();

  const lcElement = currentCurriculum?.lcElements?.children?.sort((a, b) => b.position - a.position)[0];

  if (!currentCurriculum || !lcElement) return <></>;

  const onChange = (e) => {
    dispatch(updateDashboardLearningContinuum(e.target.value));
  };

  return (
    <div className='min-w-150px max-w-250px'>
      <SelectMultipleField
        id='learning-continuum'
        placeholder={lcElement.name}
        value={lcIds}
        options={options.map((option) => ({ value: option._id, label: option?.lcElements?.[lcElement._id] }))}
        onChange={onChange}
      />
    </div>
  );
};

export default SelectLearningContinuumSimple;
